<template>
  <router-view :test="reloadMainSite"></router-view>
</template>

<script>
import { router } from '@/router'
import { mapGetters } from 'vuex'

export default {
  name: 'HomeNavigation',
  router,
  created: function () {
    // this.mainSite()
  },
  props: {},
  data: () => ({}),
  computed: {
    ...mapGetters(['isHomeNavActive']),
    reloadMainSite: function () {
      if (this.isHomeNavActive && !this.$router.currentRoute.name) {
        this.mainSite()
      }
    }
  },
  methods: {
    mainSite () {
      this.$router.currentRoute.name !== 'Homepage' &&
        this.$router.push({ name: 'Homepage' })
    }
  },
  mounted: function () {
    this.$emit('navigatorLoaded')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/HomeNavigation.vue